import { render, staticRenderFns } from "./ContestFinancialSettingsView.vue?vue&type=template&id=67571ea8&scoped=true&"
import script from "./ContestFinancialSettingsView.vue?vue&type=script&lang=js&"
export * from "./ContestFinancialSettingsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67571ea8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VCardTitle } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
installComponents(component, {VCard,VCardTitle,VFlex})
